/**
 * The portal's magic link token in `sessionStorage['brimo.portal.magic']` (F2 brief): kept while the customer fills
 * the self-disclosure behind it (`/sd/<token>`), so the confirmation page can lead back to `/portal/m/<token>`
 * (Portal 08). Storage may be unavailable (private mode) — then the flow simply ends on the confirmation.
 */

const KEY = 'brimo.portal.magic';

export function readPortalMagicToken(): string | null {
  try {
    const value = window.sessionStorage.getItem(KEY);
    return value && /^[A-Za-z0-9_-]{20,128}$/.test(value) ? value : null;
  } catch {
    return null;
  }
}

export function storePortalMagicToken(token: string): void {
  try {
    window.sessionStorage.setItem(KEY, token);
  } catch {
    // no storage: the confirmation page shows no portal button
  }
}

export function clearPortalMagicToken(): void {
  try {
    window.sessionStorage.removeItem(KEY);
  } catch {
    // nothing stored
  }
}

/** Router state of `/portal/m/<token>` when the customer arrives from the submitted self-disclosure. */
export interface MagicArrivalState {
  fromSubmit: true;
}

export function portalMagicPath(token: string): string {
  return `/portal/m/${encodeURIComponent(token)}`;
}

/** Remembers the last e-mail of the login per organization (Portal 11); failures of the storage are ignored. */
export function readLastEmail(slug: string): string {
  try {
    return window.localStorage.getItem(`brimo.portal.email.${slug}`) ?? '';
  } catch {
    return '';
  }
}

export function storeLastEmail(slug: string, email: string): void {
  try {
    window.localStorage.setItem(`brimo.portal.email.${slug}`, email);
  } catch {
    // no storage
  }
}
